export const removeWhiteSpaces = (value: string) => value.replace(/ /g, '');
